export default __webpack_public_path__ + "static/media/chartError.aad1e540.svg";